// ================================
// Please keep the same naming convention
// used in the design system
// ================================

export enum TextStyle {
  // Display
  DisplayXSmall = 'DisplayXSmall',
  DisplaySmall = 'DisplaySmall',
  DisplayMedium = 'DisplayMedium',
  DisplayLarge = 'DisplayLarge',

  // Title
  TitleSmall = 'TitleSmall',
  TitleMedium = 'TitleMedium',
  TitleLarge = 'TitleLarge',
  TitleXLarge = 'TitleXLarge',

  // Highlight
  HighlightXSmall = 'HighlightXSmall',
  HighlightSmall = 'HighlightSmall',
  HighlightMedium = 'HighlightMedium',
  HighlightLarge = 'HighlightLarge',

  // Base
  BaseXSmall = 'BaseXSmall',
  BaseSmall = 'BaseSmall',
  BaseMedium = 'BaseMedium',
  BaseLarge = 'BaseLarge',

  // Utilities
  UtilitiesSmallHeavy = 'UtilitiesSmallHeavy',
  UtilitiesMediumHeavy = 'UtilitiesMediumHeavy',
  UtilitiesXSmallThin = 'UtilitiesXSmallThin',
  UtilitiesSmallThin = 'UtilitiesSmallThin',
  UtilitiesMediumThin = 'UtilitiesMediumThin'
}
